import FetchClient from 'ha/helpers/FetchClient';
import createMakeCall from 'ha/services/apiV2/createMakeCall';

import {
  getPaymentRequests,
  getPaymentRequestByHandle,
  payPaymentRequestV2,
  payPaymentRequestV2Confirm,
  cancelPaymentRequest,
  submitIdealSource,
  checkIdealStatus,
} from './paymentRequests';

import acceptPaymentPlan from './acceptPaymentPlan';
import createPaymentPlanV3 from './createPaymentPlanV3';
import getPaymentRequestsOverview from './getPaymentRequestsOverview';
import getPendingPaymentPlan from './getPendingPaymentPlan';

export type PaymentRequest = import('./paymentRequests').PaymentRequest;
export type PayReqConversationParams =
  import('./paymentRequests').PayReqConversationParams;
export type CancelPaymentRequest =
  import('./paymentRequests').CancelPaymentRequest;
export type PaymentRequestsResponse =
  import('./paymentRequests').PaymentRequestsResponse;
export type SubmitIdealSource = import('./paymentRequests').SubmitIdealSource;
export type CheckIdealStatus = import('./paymentRequests').CheckIdealStatus;

const createOsiris = (fetchClient: FetchClient) => {
  const makeCall = createMakeCall(fetchClient);

  return {
    acceptPaymentPlan: acceptPaymentPlan(makeCall),
    cancelPaymentRequest: cancelPaymentRequest(makeCall),
    checkIdealStatus: checkIdealStatus(makeCall),
    createPaymentPlanV3: createPaymentPlanV3(makeCall),
    getPaymentRequestByHandle: getPaymentRequestByHandle(makeCall),
    getPaymentRequests: getPaymentRequests(makeCall),
    getPaymentRequestsOverview: getPaymentRequestsOverview(makeCall),
    getPendingPaymentPlan: getPendingPaymentPlan(makeCall),
    payPaymentRequestV2: payPaymentRequestV2(makeCall),
    payPaymentRequestV2Confirm: payPaymentRequestV2Confirm(makeCall),
    submitIdealSource: submitIdealSource(makeCall),
  };
};

export default createOsiris;
